"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = exports.Container = void 0;

var styled_components_1 = __importStar(require("styled-components"));

exports.Container = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var _b = _a.primaryHeaderColour,
      primaryHeaderColour = _b === void 0 ? '#e7ca66' : _b,
      _c = _a.secondaryHeaderColour,
      secondaryHeaderColour = _c === void 0 ? '#db704b' : _c;
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: #2e2e2e;\n    color: black;\n    padding: 60px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    h1,\n    h2,\n    h3,\n    h4 {\n      color: ", ";\n      background: linear-gradient(\n        90deg,\n        ", ",\n        ", "\n      );\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      margin: 0 0 12px 0;\n      text-align: center;\n      font-size: 2em;\n    }\n    span {\n      color: white;\n    }\n  "], ["\n    background: #2e2e2e;\n    color: black;\n    padding: 60px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    h1,\n    h2,\n    h3,\n    h4 {\n      color: ", ";\n      background: linear-gradient(\n        90deg,\n        ", ",\n        ", "\n      );\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      margin: 0 0 12px 0;\n      text-align: center;\n      font-size: 2em;\n    }\n    span {\n      color: white;\n    }\n  "])), primaryHeaderColour, primaryHeaderColour, secondaryHeaderColour);
});
exports.Column = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 420px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 420px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;